import { UPDATE_FRACTURE_STATE, UPDATE_FRACTURE_LIST_ITEM } from "./actiontypes"
import { PAGE_LOADING, PAGE_LOADED } from "../page_details/actiontypes";
import * as API from "./api";
import { log } from "../../config/utils"

export const updateFractureState = payload => {
  return {
    type: UPDATE_FRACTURE_STATE,
    payload
  }
}

export const getAllFractureData = (data, callback) => dispatch => {
  dispatch({
    type: PAGE_LOADING,
    payload: "fracture data loading"
  });
  API.getAllFractureData(data, (error, response) => {
    log("Fracture:- getAllFractureData", response);
    dispatch({ type: PAGE_LOADED });
    if (!error && response && response.data.filters && response.data.selectedFilters) {
      dispatch(updateFractureState({
        fracture_list: response.data.fractureList,
        filters: response.data.filters,
        selected_filters: response.data.selectedFilters
      }))
      if (callback) callback()
    }
  })
}

export const updateFractureData = data => dispatch => {
  dispatch({
    type: PAGE_LOADING,
    payload: "updating"
  });
  API.updateFractureData(data, (error, response) => {
    log("Fracture:- updateFractureData", response);
    dispatch({ type: PAGE_LOADED });
    if (!error && response && response.data && response.data.updatedFractureData && response.data.updatedFractureData.id) {
      dispatch({
        type: UPDATE_FRACTURE_LIST_ITEM,
        payload: response.data.updatedFractureData
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/data/redux/fracture_details/actions.js